import Icon from '../components/Icon.vue'

Icon.register({
  'not-equal': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M416 208h-98.4l-74.5 96h172.9c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32h-247.5l-82.1 105.7c-5.4 7-15.4 8.3-22.4 3l-25.4-19.5c-7-5.4-8.3-15.4-3-22.4l51.9-66.8h-55.5c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h130l74.5-96h-204.6c-17.7 0-32-14.3-32-32v-32c0-17.7 14.3-32 32-32h279.1l82.1-105.7c5.4-7 15.4-8.3 22.4-3l25.4 19.5c7 5.4 8.3 15.4 3 22.4l-51.9 66.8h23.9c17.7 0 32 14.3 32 32v32c0 17.7-14.3 32-32 32z'
      }
    ]
  }
})
